export const isObject = (val) => {
  return val != null && typeof val === 'object' && Array.isArray(val) === false
}

export const getDateWithFormat = (date) => {
  const selectedDate = new Date(date)

  let dd = selectedDate.getDate()
  let mm = selectedDate.getMonth() + 1

  const yyyy = selectedDate.getFullYear()
  if (dd < 10) {
    dd = '0' + dd
  }
  if (mm < 10) {
    mm = '0' + mm
  }

  return `${dd}.${mm}.${yyyy}`
}

export const getToken = () => {
  let token
  try {
    token =
      localStorage.getItem('token') !== null
        ? localStorage.getItem('token')
        : null
  } catch (error) {
    console.log(error)
    token = null
  }
  return token
}

export const setToken = (token) => {
  try {
    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
  } catch (error) {
    console.log(error)
  }
}

export const parseJson = (json) => {
  try {
    return JSON.parse(json)
  } catch (_err) {
    return false
  }
}

export const formatPhoneNumber = (phoneNumberString) => {
  return phoneNumberString.replaceAll(/\D/gi, '')
}

export const beautifyPhoneNumber = (string) => {
  const cleaned = formatPhoneNumber(string)
  const match = cleaned.match(/^(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})$/)
  return `+${match[1]} ${match[2]} ${match[3]}-${match[4]}-${match[5]}`
}

export const ObjectFilterOut = (object, filterKeys) => {
  const langFilterKeys = []
  for (const key of filterKeys) {
    langFilterKeys.push(key.concat('_', 'en'))
    langFilterKeys.push(key.concat('_', 'ru'))
  }
  const asArray = Object.entries(object)
  const filtered = asArray.filter(
    // eslint-disable-next-line no-unused-vars
    ([key, _value]) => !langFilterKeys.includes(key)
  )
  return Object.fromEntries(filtered)
}

export const handleArrayDataInternalization = (data, langKeys, currentLang) => {
  switch (currentLang) {
    case 'en':
      return data.map((i) => {
        const langData = {}

        for (const key of langKeys) {
          const langKey = key.concat('_', 'en')
          if (i[langKey]) {
            langData[key] = i[langKey]
          }
        }

        return {
          ...ObjectFilterOut(i, langKeys),
          ...langData
        }
      })

    case 'ru':
      return data.map((i) => {
        const langData = {}

        for (const key of langKeys) {
          const langKey = key.concat('_', 'ru')
          if (i[langKey]) {
            langData[key] = i[langKey]
          }
        }

        return {
          ...ObjectFilterOut(i, langKeys),
          ...langData
        }
      })

    default:
      return []
  }
}

export const handleObjectInternalization = (data, langKeys, currentLang) => {
  const langData = {}
  switch (currentLang) {
    case 'en':
      for (const key of langKeys) {
        const langKey = key.concat('_', 'en')
        if (data[langKey]) {
          langData[key] = data[langKey]
        }
      }

      return {
        ...ObjectFilterOut(data, langKeys),
        ...langData
      }

    case 'ru':
      for (const key of langKeys) {
        const langKey = key.concat('_', 'ru')
        if (data[langKey]) {
          langData[key] = data[langKey]
        }
      }

      return {
        ...ObjectFilterOut(data, langKeys),
        ...langData
      }

    default:
      return []
  }
}

export const findObjectInArray = (arr = [], param, query) => {
  if ((Array.isArray(arr) && arr.length === 0) || !param || !query) return {}
  const obj = arr.find((el) => el[param] === query)
  return (isObject(obj) && obj) || {}
}

export const handleFilter = (featureData, patternType, objectFilterId) => {
  if (!isObject(patternType) || !Array.isArray(featureData)) return []
  const id = patternType.id
  return featureData.filter((item) => {
    const jsondata = parseJson(item.json_data)
    if (!jsondata && !isObject(jsondata)) return false
    const jsonId = findObjectInArray(jsondata, 'id', objectFilterId)
    if (Object.keys(jsonId).length === 0) return false
    return jsonId.data === id
  })
}
